module.exports = __webpack_public_path__ + "static/fastFood-39c52f5fc6f1bd83810e1cd3320df43c.png";